import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RicercaPolizzeComponent } from './ricerca-polizze.component';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [RicercaPolizzeComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
  ],
  exports: [RicercaPolizzeComponent],
})
export class RicercaPolizzeModule { }
